module.exports = __webpack_public_path__ + "static/media/18-roz-closet-09_28_2020.441b57b5.jpg";